import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "../../../hooks/useAppContext";

interface IMapStyle {
	name: string;
	id: string;
	url: string;
}

/**
 * Get all styles with a thumb url
 */
export const useMapStyles = () => {
	const {
		context,
		reactQueryNoReloadOptions,
		client,
		platform: { ajax },
	} = useAppContext();

	const getMapStylesAsync = async () => {
		// URL invalidation at new version
		const url = `${context.osmTileServerUrl}/${client.stampRelativeUrl("styles.json")}`;
		const styles = await ajax.getJSON<IMapStyle[]>(url);

		const stylesWithThumb = styles.map((style) => {
			return {
				...style,
				url: `${context.osmTileServerUrl}/styles/${style.id}/14/8391/5497.png`,
			};
		});

		// Sort styles by name
		return stylesWithThumb.sort((s1, s2) => {
			if (s1.name > s2.name) {
				return 1;
			}

			if (s1.name < s2.name) {
				return -1;
			}

			return 0;
		});
	};

	return useQuery(["use-map-styles", context.osmTileServerUrl], getMapStylesAsync, {
		enabled: !!context.osmTileServerUrl,
		...reactQueryNoReloadOptions,
		retry: 4,
		meta: {
			logToServer: true,
			errorPrefix: "Error loading map styles",
		},
	});
};
